import { createAsyncThunk } from '@reduxjs/toolkit';
import { getParams } from '../common/get-params';

let drilldownControllerRef = null;
const getInterviewCard = async (
  { timeFrame = {}, filters = {} },
  { extra: { atsHttp } }
) => {
  const params = getParams({ timeFrame, filters, compare: true });
  const hireCardResponse = atsHttp.post(`/reports/interviews/card`, params);
  return hireCardResponse;
};

const getInterviewTableAndChart = async (
  { timeFrame = {}, group = {}, filters = {} },
  { extra: { atsHttp } }
) => {
  const params = getParams({ timeFrame, group, filters });
  const hireCardResponse = atsHttp.post(
    `/reports/interviews/chart_table`,
    params
  );
  return hireCardResponse;
};

const getInterviewVisual = async (
  { timeFrame = {}, group = {}, filters = {} },
  { extra: { atsHttp } }
) => {
  const params = getParams({ timeFrame, group, filters });
  const hireCardResponse = atsHttp.post(`/reports/interviews/visual`, params);
  return hireCardResponse;
};

const getInterviewDrilldown = async (
  { timeFrame = {}, group = {}, filters = {}, drilldown = {}, customFilter },
  { extra: { atsHttp } }
) => {
  if (drilldownControllerRef) {
    drilldownControllerRef.abort();
  }

  // Create a new controller for this request
  const controller = new AbortController();
  drilldownControllerRef = controller;
  try {
    const params = getParams({
      timeFrame,
      group,
      filters,
      drilldown,
      customFilter,
    });
    const response = await atsHttp.post(
      `/reports/interviews/drilldown`,
      params,
      {
        signal: controller.signal,
      }
    );
    return response;
  } catch (error) {
    if (error.name === 'AbortError' || error.name === 'CanceledError') {
      throw error;
    }
    throw error;
  }
};

export const fetchInterviewCard = createAsyncThunk(
  'ats-reports/interview/card',
  getInterviewCard
);

export const fetchInterviewTableAndChart = createAsyncThunk(
  'ats-reports/interview/table-chart',
  getInterviewTableAndChart
);

export const fetchInterviewVisual = createAsyncThunk(
  'ats-reports/interview/feedback/visual',
  getInterviewVisual
);

export const fetchInterviewDrilldown = createAsyncThunk(
  'ats-reports/interviews/drilldown',
  getInterviewDrilldown
);
